import { css, keyframes } from 'styled-components';
import token from 'styled-token';
import { animationA11yMixin } from './animationA11yMixin';
var fadeInKeyframes = /*#__PURE__*/keyframes(["from{opacity:0;}to{opacity:1;}"]);

/** @mixin animationFadeInMixin */
/**
 * Adds a fade in animation to a component that meets a11y standards.
 *
 * @example
 * import { animationFadeInMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${animationFadeInMixin}
 * `;
 *
 * <Component>My animated component</Component>
 *
 * @method
 * @return {CSSObject}
 */
export var animationFadeInMixin = token({
  duration: 'animations.defaultDuration',
  timing: 'animations.defaultTimingFunction'
}, function (tokens) {
  return animationA11yMixin(css(["animation:", " ", "s ", ";"], fadeInKeyframes, tokens.duration, tokens.timing));
});